export default "__VITE_ASSET__CQ55vBQY__"